import { State } from '../../reducers/rootReducer'
import { RecommendationsData } from '../../../entities/RecommendationsData'

const vwnModelsWithRecommendationsDataSelector = (state: State): RecommendationsData => state.vwnModelsWithRecommendations

export default vwnModelsWithRecommendationsDataSelector
